import script from "./followList.vue?vue&type=script&setup=true&lang=js"
export * from "./followList.vue?vue&type=script&setup=true&lang=js"

import "./followList.vue?vue&type=style&index=0&id=6801c9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6801c9d0"]])

export default __exports__